import { Archive, BookOpen, ExternalLink } from 'lucide-react';
import { Link } from 'react-router-dom';

const linkClass =
  'inline-flex min-h-11 items-center justify-center rounded-lg px-5 py-3 font-outfit text-sm font-semibold transition focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ivory-accent/50';

export default function ArchiveNotice() {
  return (
    <div className="min-h-screen bg-ivory-bg text-ivory-ink font-sans antialiased">
      <header className="border-b border-ivory-border bg-ivory-surface">
        <div className="mx-auto flex min-h-20 max-w-landing items-center justify-between gap-4 px-4 sm:px-6 lg:px-12">
          <Link
            to="/"
            className="font-playfair text-2xl font-bold tracking-tight focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ivory-accent/50 rounded-md"
          >
            MyLegal<span className="text-ivory-accent">AI</span>
            <span className="ml-2 font-outfit text-sm font-bold uppercase tracking-widest text-ivory-accent">
              MY
            </span>
          </Link>
          <nav className="flex items-center gap-2 text-sm sm:gap-4" aria-label="Archive">
            <Link to="/resources" className="rounded-md px-2 py-2 text-ivory-muted hover:text-ivory-ink">
              Resources
            </Link>
            <Link to="/privacy" className="hidden rounded-md px-2 py-2 text-ivory-muted hover:text-ivory-ink sm:inline-flex">
              Privacy
            </Link>
          </nav>
        </div>
      </header>

      <main className="mx-auto flex max-w-3xl flex-col gap-8 px-4 py-16 sm:px-6 sm:py-24 lg:px-8">
        <div className="flex h-14 w-14 items-center justify-center rounded-2xl bg-ivory-surface-high text-ivory-accent ring-1 ring-ivory-border">
          <Archive className="h-7 w-7" aria-hidden />
        </div>
        <div className="space-y-5">
          <p className="font-outfit text-xs font-semibold uppercase tracking-[0.2em] text-ivory-accent">
            MyLegalAI · static archive
          </p>
          <h1 className="font-playfair text-4xl font-bold leading-tight tracking-tight sm:text-6xl">
            The interactive service has been archived.
          </h1>
          <p className="text-lg leading-relaxed text-ivory-muted sm:text-xl">
            MyLegalAI was an experimental public-interest project. The interactive AI service is no longer accepting users.
          </p>
        </div>

        <div role="alert" className="rounded-2xl border border-ivory-accent/30 bg-ivory-surface p-6 shadow-sm sm:p-8">
          <p className="font-outfit text-base font-semibold text-ivory-ink">What is unavailable</p>
          <p className="mt-3 leading-relaxed text-ivory-muted">
            Accounts, uploads, chat, document analysis, and templates are unavailable. This site does not provide account access, submissions, or interactive AI processing.
          </p>
        </div>

        <div className="grid gap-4 sm:grid-cols-2">
          <Link to="/" className={`${linkClass} bg-ivory-ink text-white hover:bg-ivory-accent`}>
            <BookOpen className="mr-2 h-4 w-4" aria-hidden />
            Browse the archive
          </Link>
          <Link to="/resources" className={`${linkClass} border border-ivory-border bg-ivory-surface text-ivory-ink hover:bg-ivory-surface-low`}>
            <ExternalLink className="mr-2 h-4 w-4" aria-hidden />
            Find official resources
          </Link>
        </div>

        <div className="border-t border-ivory-border pt-6 text-sm leading-relaxed text-ivory-muted">
          <p>
            Remaining material is informational only. It is not legal advice and does not create a lawyer-client relationship. Verify current law and contact a qualified Malaysian lawyer for advice about your situation.
          </p>
          <p className="mt-4">
            See the <Link to="/privacy" className="text-ivory-accent underline underline-offset-4">privacy policy</Link> and <Link to="/terms" className="text-ivory-accent underline underline-offset-4">terms</Link> for the static archive.
          </p>
        </div>
      </main>
    </div>
  );
}
